import { useSelector } from 'react-redux';
import { useState } from 'react';
import debounce from 'lodash/debounce';
import { useGlobalContext } from '../provider/global/GlobalContext';

const warningMessage = 'We are unable to verify your email and recommend you check the email entered. You can still continue with your order.';

const getAddressData = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    console.error('Error from Fetch:', error);
  }
};

const handleEmailValidation = debounce(async (
  {
    email,
    projectConfig,
    setValidate,
    resolve,
    setEmailStatus,
    requestKey,
    setFormError,
    setInputResult,
  }
) => {
  setValidate && setValidate(true);

  const params = new URLSearchParams({
    Method: 'DataTools.Verify.Email.BriteVerify.VerifyEmail',
    EmailAddress: email,
    DepartmentCode: 'saba',
    RequestKey: requestKey,
    OutputFormat: 'json',
  });

  return getAddressData(projectConfig.datatools.url + '?' + params).then(
    (data) => {
      const result = data?.DtResponse?.Result?.[0];
      if (result?.StatusCode === '0' || result?.StatusCode === '1' || result?.StatusCode === '3') {
        setEmailStatus && setEmailStatus(result?.StatusCode);
        setValidate && setValidate(false);
        setInputResult && setInputResult(result);
        resolve(true);
        return result?.StatusCode;
      }

      if (result?.StatusCode === '2') {
        setEmailStatus && setEmailStatus(result?.StatusCode);
        setValidate && setValidate(false);
        resolve(false);
        setFormError('This email seems to be incorrect, please review and try again.');
        return result?.StatusCode;
      }
    },
  );
}, 400);


export const useEmailValidation = () => {
  const projectConfig = useSelector(
    (state) => state.app.context.project.configuration,
  );

  const { requestKey } = useGlobalContext();

  const [isEmailValidationLoading, setIsEmailValidationLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);

  return {
    requestKey,
    projectConfig,
    isEmailValidationLoading,
    setIsEmailValidationLoading,
    emailStatus,
    setEmailStatus,
    warningMessage,
    handleEmailValidation,
  }
};
